export default "/apps/maps/img/marker-shadow.png";